<template>
    <section class="content">
        <div class="container-fluid">

            <div class="row">
                        
                <div class="col-sm-12">  
                    <div class="card">
                        <div class="card-header">
                            <div class="row">                                                   
                                <div class="col">
                                    <h5>Transaction List (current pay period)</h5>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <div class="table-responsive">
                                <table class="table table-striped table-bordered" id="anet_table">
                                    <thead>
                                        <tr>
                                            <th>Invoice No</th>
                                            <th>Submit Date</th>
                                            <th>Customer</th>
                                            <th>Amount</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in AnetData" >
                                            <td>{{item.invoice_no}}</td>
                                            <td>{{item.submit_date}}</td>
                                            <td>{{item.customer}}</td>
                                            <td>{{item.amount}}</td>
                                            <td>{{item.trans_status}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>

    export default {
        data () {

            return {
                TableHeaders: {},
                AnetData: {},
            }

        },
        mounted() {


        },
        updated: function () {

          this.$nextTick(function () {
                $('#anet_table').DataTable({order: [[1, 'desc']]});
          })

        },
        methods: {
            getStatsData() {
                axios.get("/api/v1/anetapi/transactions").then(({ data }) => {
                    this.AnetData = data.data.AnetData
                    console.log(this.AnetData);
                });
            }

        },
        created() {

            this.getStatsData();
        }
    }
</script>
